import type { FC, ReactNode } from 'react';
import styles from './ModalFooter.module.css';

interface ModalFooterProps {
  className?: string;
  children: ReactNode;
}

export const ModalFooter: FC<ModalFooterProps> = ({ className, children }) => (
  <div className={className ? `${styles.footer} ${className}` : styles.footer}>{children}</div>
);

export const destructiveButtonClass = styles.destructiveButton;
